// The #app-strings block is server-rendered once (via JSP <fmt:message>) and never
// mutated at runtime, so we read every label into a cache on first use instead of
// doing a document.querySelector DOM lookup on every getLabelFromJspVariables call.
let _labelCache = null;

function getLabelCache() {
    if (_labelCache === null) {
        _labelCache = {};
        const container = document.getElementById('app-strings');
        if (container) {
            const spans = container.querySelectorAll('span[id]');
            for (let i = 0; i < spans.length; i++) {
                _labelCache[spans[i].id] = spans[i].innerText;
            }
        }
    }
    return _labelCache;
}

// Returns the raw resource text for key, or undefined if the key is not defined.
function lookupLabel(key) {
    const cache = getLabelCache();
    return Object.prototype.hasOwnProperty.call(cache, key) ? cache[key] : undefined;
}

export function getLabelFromJspVariables(key) {
    let val = lookupLabel(key);
    if (val !== undefined) {
        for (let i = 0; i < arguments.length - 1; i++) {
            val = val.replace('{' + i + '}', arguments[i + 1]);
        }
    } else {
        console.log("unable to translate string " + key);
        val = key;
    }
    return val;
}

// Resource-first message resolution: returns the resource text for `key` if defined,
// otherwise the provided `fallback` (e.g. a server response message), otherwise the key.
export function getLabelOrDefault(key, fallback) {
    const val = lookupLabel(key);
    if (val !== undefined) {
        return val;
    }
    return (typeof fallback !== 'undefined' && fallback !== null) ? fallback : key;
}

export function isValueAvailable(key) {
    if (typeof (key) === 'undefined') {
        return false;
    }
    if (key === '') {
        return false;
    }
    return true;
}
